/**
 *  Filename ....: dw-spinner.component.ts
 *  Created by ..: ianday
 *  on Date .....: 11/27/23
 **/
import {Component, Input, OnInit} from '@angular/core';

@Component({
    selector: 'app-dw-spinner',
    templateUrl: './dw-spinner.component.html',
    styleUrls: ['./dw-spinner.component.css']
})

export class DwSpinnerComponent implements OnInit {

    public _waitMessage: string | null = 'Loading (Please Wait) ...';
    public _visible: boolean | null = false;

    @Input() set waitMessage(val: string) {
        this._waitMessage = val;
    }
    public get waitMessage(): string {
        return this._waitMessage;
    }

    @Input() set visible(val: boolean) {
        this._visible = val;
    }
    public get visible(): boolean {
        return this._visible;
    }

    constructor() {

    }

    ngOnInit() {

    }
}


